import React, { useMemo } from "react";
import { StackScreenProps } from "@react-navigation/stack";
import { RootStackParamList } from "../navigations/RootNavigation";
import Text from "../components/Text";
import { TitleMediumText } from "../components/FormattedText";
import VStack from "../ui_atoms/VStack";
import { useI18n } from "../hooks/i18n-hooks";
import ListItem from "../ui_atoms/ListItem";
import { FeeType, RepetitionType } from "../__generated__/graphql";
import Gap from "../ui_atoms/Gap";
import { formatCurrency } from "../utils";

type FeesDetailsProps = StackScreenProps<RootStackParamList, "FeesDetails">;

const FeesDetailsScreen = ({ route }: FeesDetailsProps) => {
    const i18n = useI18n();
    const { fees, deductions } = useMemo(() => route.params, [route.params]);

    return (
        <>
            <VStack h="2/3">
                <TitleMediumText>
                    {i18n.t("screens.fees_and_deductions.employeer_fees")}
                </TitleMediumText>
            </VStack>
            <Gap gap={0.5} />
            <>
                {fees.map((fee, index) => (
                    <ListItem
                        key={index}
                        icon="receipt"
                        title={
                            fee.type === FeeType.Other
                                ? i18n.t("fees.type.otherText.title", {
                                      text: fee.otherTitle || "???",
                                  })
                                : fee.type === FeeType.Cct
                                  ? i18n.t("screens.fees_and_deductions.cct_fees")
                                  : i18n.t(`fees.type.${fee.type}.title`)
                        }
                        description={i18n.t("screens.fees_and_deductions.fees_description", {
                            repetition:
                                fee.repetition === RepetitionType.WorkedMonth
                                    ? i18n.t("fees.repetition.total")
                                    : i18n.t(`fees.repetition.${fee.repetition}`),
                            amount: formatCurrency({
                                amountInCents: fee.amount,
                                displayDigitsWhenNoCents: false,
                            }),
                        })}
                    />
                ))}
            </>
            <Gap gap={1} />
            <VStack h="2/3">
                <TitleMediumText>
                    {i18n.t("screens.fees_and_deductions.talent_fees")}
                </TitleMediumText>
            </VStack>
            <Gap gap={0.5} />
            <>
                {deductions.map((deduction, index) => (
                    <ListItem
                        key={index}
                        icon="receipt"
                        title={deduction.description}
                        description={i18n.t("screens.fees_and_deductions.fees_description", {
                            repetition:
                                deduction.repetition === RepetitionType.WorkedMonth
                                    ? i18n.t("fees.repetition.total")
                                    : i18n.t(`fees.repetition.${deduction.repetition}`),
                            amount: formatCurrency({
                                amountInCents: deduction.amount,
                                displayDigitsWhenNoCents: false,
                            }),
                        })}
                    />
                ))}
            </>
        </>
    );
};

export default FeesDetailsScreen;
